import { render, staticRenderFns } from "./detailedList.vue?vue&type=template&id=2a18e3ad&scoped=true&"
import script from "./detailedList.vue?vue&type=script&lang=js&"
export * from "./detailedList.vue?vue&type=script&lang=js&"
import style0 from "./detailedList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./detailedList.vue?vue&type=style&index=1&id=2a18e3ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a18e3ad",
  null
  
)

component.options.__file = "detailedList.vue"
export default component.exports